import request from '../../utils/request';

// 撤销商行签字
export async function cancelSign(params) {
  return request({ url: `stall/business/sign/invalid`, params, headers: 'json' });
}
